class IndexRecentlyViewed extends HTMLElement {
    constructor() {
        super();
        this.wrapper = this.querySelector('.js-recently-viewed-wrapper');
        this.splitContainer = this.querySelector('.js-recently-viewed-split-container');
        this.slider = this.querySelector('.recently-viewed-product-slider');
        this.init();
    }

    init() {

        const productTemplateId = 'index-recently-viewed-product-template'
        const wrapperId = this.slider.id;

        const list = Shopify.Products.getList() || [];

        //show section
        if (list.length > 0) {

            this.show();

            if (list.length == 1) {
                this.slider.classList.add('has-only-one-item')
            }
        } else {
            return
        }

        Shopify.Products.showRecentlyViewed({
            wrapperId: wrapperId,
            templateId: productTemplateId,
            onComplete: this.loadComplete.bind(this)
        })
    }

    show() {
        this.wrapper.style.display = "block";
    }

    loadComplete() {
        console.log('slider', this.slider)

        const slider = this.slider;
        if (!slider) return;

        const initFlickity = () => {
            const flkty = new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                wrapAround: false,
                pageDots: true,
                prevNextButtons: true,
                draggable: true,
                imagesLoaded: true
            });

            slider.dataset.flickityInitialized = 'true';
            slider.classList.add('flickity-initialized');
        };

        if (window.theme && window.theme.whenFlickityReady) {
            window.theme.whenFlickityReady(initFlickity);
        } else if (window.Flickity) {
            initFlickity();
        }

        //call parallax after
        //this.parallax();

    }

    /*
    parallax(){
        jarallaxElement();
        jarallax(this.container);
        console.log('recent init parallax');
    }
    */
  

}
  
  customElements.define('index-recently-viewed', IndexRecentlyViewed);
